export default __webpack_public_path__ + "static/media/cloud-upload.45c98620.png";